// Shown as the author of a note the SYSTEM wrote rather than a person.
//
// Distinct from the 'System' label below on purpose: that one is opt-in via `isSystem` at call
// sites that already know they are rendering a system actor (e.g. the transactions table). This
// one is the notes table's fallback for a note whose `createdBy` is absent — which the backend
// writes DELIBERATELY for the payment "submitted for processing" note (the operator id is not
// threaded into that call, and `createdBy` is optional on the note schema). Those notes are
// client-visible, and before this they rendered the developer placeholder below.
export const SYSTEM_NOTE_AUTHOR = 'Accounting Bot'

const AFFILIATE_ASSIGNEE_ROLES = ['affiliate']

const idOf = (user) => user?._id || user?.id

export const splitAssignees = ({ creator, creatorRole, assignees = [], officeName = '' }) => {
  const creatorId = idOf(creator)
  const own = assignees.find((assignee) => creatorId && idOf(assignee) === creatorId)
  const groupNames = (own?.contactGroups || []).map((group) => group?.name).filter(Boolean)
  const isAffiliate = Boolean(creatorId) && AFFILIATE_ASSIGNEE_ROLES.includes(creatorRole)

  return {
    affiliate: isAffiliate
      ? { name: `${creator.firstName || ''} ${creator.lastName || ''}`.trim(), office: groupNames.length ? groupNames.join(', ') : officeName }
      : null,
    internal: assignees.filter((assignee) => !isAffiliate || idOf(assignee) !== creatorId),
  }
}

export const formatUserWithContactGroups =({ user, userRole, isSystem = false, contactGroupsMap = {} }) => {
  if (!user) {
    return isSystem ? 'System' : '!! creator not found'
  }

  const name = user.firstName + ' ' + user.lastName

  // Support both object format (with name) and ID format (needs map lookup)
  const contactGroupNames = user.contactGroups?.map(group => {
    if (typeof group === 'string') {
      return contactGroupsMap[group]
    }
    return group?.name
  }).filter(Boolean)

  const contactGroup = contactGroupNames?.length > 0 ? `(${contactGroupNames.join(', ')})` : ''

  return `${name} ${userRole !== 'affiliate' ? contactGroup : ''}`
}

